const data = {
  'Selected': 'נבחרו: {0} מתוך {1}',
  'Uploading files': 'העלאה {0}% מתוך {1}',
  'File size error': '{0} הוא קובץ גדול מדי. אנא העלו עד לגודל של {1}',
  'Upload failed': '{0} לא הועלה כמו שצריך. אנא נסו שנית',
  'Upload summary': '{0} הצליחו, {1} נכשלו, {2} סה״כ',
  'Per page': '{0} לעמוד',
  'Folder': 'תיקייה',
  'Login failed, please try again': 'הכניסה נכשלה, אנא בידקו שם משתמש וסיסמה',
  'Already logged in': 'אתם כבר מחוברים לאתר.',
  'Please enter username and password': 'לכניסה למערכת הקלידו שם משתמש וסיסמה.',
  'Not Found': 'לא נמצא',
  'Not Allowed': 'הפעולה לא מותרת',
  'Please log in': 'אנא בצעו כניסה לאתר',
  'Unknown error': 'שגיאה',
  'Add files': 'הוספת קבצים',
  'New': 'חדש',
  'New name': 'שם חדש',
  'Username': 'שם משתמש',
  'Password': 'סיסמה',
  'Login': 'כניסה למערכת',
  'Logout': 'התנתקות',
  'Profile': 'פרופיל',
  'No pagination': 'ללא דפדוף בין עמודים',
  'Time': 'זמן',
  'Name': 'שם',
  'Size': 'גודל',
  'Home': 'ראשי',
  'Copy': 'העתקה',
  'Move': 'העברה',
  'Rename': 'שינוי שם',
  'Required': 'נא למלא חלק זה',
  'Zip': 'כיווץ זיפ',
  'Batch Download': 'הורדה מרובת קבצים',
  'Unzip': 'פריסת קובץ זיפ',
  'Delete': 'מחיקה',
  'Download': 'הורדה',
  'Copy link': 'העתקת קישור',
  'Done': 'סיום',
  'File': 'קובץ',
  'Drop files to upload': 'גררו קבצים לכאן כדי להעלותם',
  'Close': 'סגירה',
  'Select Folder': 'בחירת תיקייה',
  'Users': 'משתמשים',
  'Files': 'קבצים',
  'Role': 'הרשאות',
  'Cancel': 'ביטול',
  'Paused': 'מוקפא',
  'Confirm': 'אישור',
  'Create': 'יצירה',
  'User': 'שם משתמש',
  'Admin': 'ניהול',
  'Save': 'שמירה',
  'Read': 'קריאה',
  'Write': 'כתיבה',
  'Upload': 'העלאה',
  'Permissions': 'הרשאות',
  'Homedir': 'תיקייה ראשית',
  'Leave blank for no change': 'השאירו ריק כדי להותיר ללא שינוי',
  'Are you sure you want to do this?': 'האם אתם בטוחים שברצונכם לעשות פעולה זו?',
  'Are you sure you want to allow access to everyone?': 'האם אתם בטוחים שתרצו לאפשר גישה לכולם?',
  'Are you sure you want to stop all uploads?': 'האם אתם בטוחים שתרצו לעצור את כל ההעלאות?',
  'Something went wrong': 'משהו השתבש',
  'Invalid directory': 'תיקייה שגויה',
  'This field is required': 'חובה למלא חלק זה',
  'Username already taken': 'שם המשתמש הזה כבר קיים',
  'User not found': 'המשתמש לא נמצא',
  'Old password': 'הסיסמה הישנה',
  'New password': 'הסיסמה החדשה',
  'Wrong password': 'סיסמה שגויה',
  'Updated': 'עודכן',
  'Deleted': 'נמחק',
  'Your file is ready': 'הקובץ שלכם מוכן!',
  'View': 'צפייה',
  'Search': 'חיפוש',
  'Download permission': 'הורדה',
  'Guest': 'אורח/ת',
  'Show hidden': 'הצגת קבצים מוסתרים',
  'Show symbolic format': 'הצג פורמט סמלי',
  'Hide symbolic format': 'הסתר פורמט סמלי',
}

export default data
